import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/dramas";

export default function SiteFooter() {
  const [expanded, setExpanded] = useState(false);
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200/60 bg-primary-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-semibold text-background-50">
                结
              </span>
              <span className="font-heading text-base font-semibold text-foreground-950">
                波多野结衣家庭教师
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              专注热门电视剧的剧情介绍与角色分析，为喜欢深挖故事的你，整理每一部剧值得被记住的细节。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-500/30 text-primary-500">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-500/30 text-primary-500">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-500/30 text-primary-500">
                <i className="ri-mail-line text-sm"></i>
              </span>
              <span className="ml-2 text-xs text-foreground-600">内容演示站点 · 非商业用途</span>
            </div>
          </div>

          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="flex cursor-pointer items-center justify-between rounded-md border border-background-300/40 px-4 py-3 font-label text-sm text-foreground-700 md:hidden"
          >
            站点导航与联系方式
            <i className={`${expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base`}></i>
          </button>

          <div className={`${expanded ? "grid" : "hidden"} gap-8 sm:grid-cols-2 md:grid md:grid-cols-3`}>
            <div>
              <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-500">
                <Link to="/category" className="cursor-pointer">页面导航</Link>
              </h4>
              <ul className="mt-3 space-y-2 text-sm text-foreground-700">
                <li><Link to="/" className="cursor-pointer transition-colors hover:text-accent-500">首页</Link></li>
                <li><Link to="/category" className="cursor-pointer transition-colors hover:text-accent-500">电视剧分类</Link></li>
                <li><Link to="/search" className="cursor-pointer transition-colors hover:text-accent-500">搜索结果</Link></li>
                <li><Link to="/about" className="cursor-pointer transition-colors hover:text-accent-500">关于我们</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-500">
                <Link to="/category" className="cursor-pointer">热门分类</Link>
              </h4>
              <ul className="mt-3 space-y-2 text-sm text-foreground-700">
                {categories.slice(0, 4).map((item) => (
                  <li key={item.name}>
                    <Link
                      to={`/category?type=${encodeURIComponent(item.name)}`}
                      className="cursor-pointer transition-colors hover:text-accent-500"
                    >
                      {item.name}剧集
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-500">
                <Link to="/about" className="cursor-pointer">联系我们</Link>
              </h4>
              <ul className="mt-3 space-y-2 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className="ri-mail-line text-sm"></i>
                  </span>
                  editor@dramajournal.example
                </li>
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className="ri-time-line text-sm"></i>
                  </span>
                  工作日 10:00 - 19:00
                </li>
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className="ri-map-pin-line text-sm"></i>
                  </span>
                  线上编辑部 · 内容演示
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-background-300/30 pt-5 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 波多野结衣家庭教师 · 影视剧情内容演示站</p>
          <p className="flex items-center gap-4">
            <span>本站不提供完整剧集播放与下载</span>
            <Link to="/about" className="cursor-pointer text-accent-600 transition-colors hover:text-accent-500">
              内容说明
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}